<template>
	<div class="row">
		<div class="col-6">
			<a v-if="bet.result.key !== 'cancelled'" class="btn btn-block btn-outline-danger text-white" v-on:click="cancel">{{ t.cancel }}</a>
			<a v-if="bet.result.key === 'cancelled'" class="btn btn-block btn-primary" v-on:click="cancel">{{ t.cancel_back }}</a>
		</div>
		<div class="col-6">
			<a class="btn btn-block btn-outline-primary text-danger">{{ t.re_compute }}</a>
		</div>
	</div>
</template>

<script>
    export default {
        name: "betActions",
	    data () {
            return {
                t: this.$root.t
            }
	    },
	    props: ['bet'],
	    methods: {
			cancel () {

			    var th = this;
			    var message = (this.bet.result.key === 'waiting') ? this.t.alert.cancel_bet_message : '';

                swal({
                    title: th.t.alert.are_you_sure,
                    text: message,
                    icon: "warning",
                    buttons: [
                        th.t.alert.button.not_sure,
                        th.t.alert.button.yes
                    ],
                    dangerMode: true,
                }).then(function(isConfirm) {
                    if (isConfirm) {

                        th.$http.get(api+'api/v1/bet/cancel/'+th.bet.id)
                            .then(response => {

		                        swal({
		                            title: th.t.alert.success,
		                            text: th.t.processing.success,
		                            icon: 'success'
		                        }).then(function() {
                                    th.$emit("success", true);
		                        });



                    }, response => {

                    })

                    } else {


                    }
                })

			},
		    restart () {

		    }
	    }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/user/bets/betActions.vue